import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { Button } from '../../AORedesign';
import WorkflowDialog from './WorkflowDialog';

const WorkflowViewContainer = ({ appBarTitle, block, buttonLabel, children, startIcon, handleResetOnClose, TriggerButton, handleCloseRef }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

    // call method if passed/defined
    handleResetOnClose?.();
  };

  useEffect(() => {
    if (handleCloseRef) {
      handleCloseRef.current = handleClose;
    }
  }, [handleCloseRef]);

  const renderTrigger = () => {
    if (TriggerButton) {
      return React.createElement(TriggerButton, { onClick: handleClickOpen });
    } else {
      return (
        <Button variant="text" color="secondary" onClick={handleClickOpen} startIcon={startIcon}>
          {buttonLabel}
        </Button>
      );
    }
  };

  return (
    <>
      {renderTrigger()}
      <WorkflowDialog appBarTitle={appBarTitle} handleClose={handleClose} open={open} block={block}>
        {children}
      </WorkflowDialog>
    </>
  );
};

WorkflowViewContainer.propTypes = {
  appBarTitle: PropTypes.string,
  block: PropTypes.bool,
  buttonLabel: PropTypes.string,
  children: PropTypes.node,
  handleResetOnClose: PropTypes.func,
  startIcon: PropTypes.node,
  TriggerButton: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  handleCloseRef: PropTypes.object,
};

export default WorkflowViewContainer;
